import React from "react"
import Icon from "../../../components/AppIcon"
import Input from "../../../components/ui/Input"
import Button from "../../../components/ui/Button"
import LessonEditor from "./LessonEditor"
import { createEmptyLesson } from "../../../utils/lessonTypes"
import { generateLocalId } from "../../../utils/courseHelpers"

const ModuleEditor = ({ module, index, onChange, onDelete, onMoveUp, onMoveDown }) => {
  const updateTitle = (e) => {
    onChange({ ...module, title: e?.target?.value })
  }

  const addLesson = () => {
    const newLesson = createEmptyLesson(generateLocalId())
    onChange({ ...module, lessons: [...(module?.lessons || []), newLesson] })
  }

  const updateLesson = (lessonId, updatedLesson) => {
    onChange({
      ...module,
      lessons: module?.lessons?.map((l) => (l?.id === lessonId ? updatedLesson : l)),
    })
  }

  const deleteLesson = (lessonId) => {
    onChange({
      ...module,
      lessons: module?.lessons?.filter((l) => l?.id !== lessonId),
    })
  }

  return (
    <div className="bg-card border border-border rounded-xl p-5 space-y-4">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-muted-foreground w-8">#{index + 1}</span>
        <div className="flex-1">
          <Input
            placeholder="Module title, e.g. Introduction to Blockchain Compliance"
            value={module?.title}
            onChange={updateTitle}
          />
        </div>
        <Button variant="ghost" size="icon" iconName="ChevronUp" iconSize={16} onClick={onMoveUp} />
        <Button variant="ghost" size="icon" iconName="ChevronDown" iconSize={16} onClick={onMoveDown} />
        <Button variant="ghost" size="icon" iconName="Trash2" iconSize={16} onClick={onDelete} />
      </div>

      <div className="space-y-3 pl-2 border-l-2 border-border">
        {module?.lessons?.length === 0 && (
          <p className="text-sm text-muted-foreground pl-3">No lessons yet.</p>
        )}
        {module?.lessons?.map((lesson) => (
          <div key={lesson?.id} className="pl-3">
            <LessonEditor
              lesson={lesson}
              onChange={(updated) => updateLesson(lesson?.id, updated)}
              onDelete={() => deleteLesson(lesson?.id)}
            />
          </div>
        ))}
      </div>

      <Button variant="outline" size="sm" iconName="Plus" iconPosition="left" onClick={addLesson}>
        Add Lesson
      </Button>
    </div>
  )
}

export default ModuleEditor